let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("zKI0V")).then(() => parcelRequire('6LL3k'));